"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var warehousesList_1 = require("common/global/warehousesList");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
function PrescriptionMedicationPrint(_a) {
    var _b, _c, _d, _e;
    var medication = _a.medication, printFnRef = _a.printFnRef, type = _a.type;
    var t = (0, react_i18next_1.useTranslation)().t;
    var medicationItemsExternal = (_b = medication === null || medication === void 0 ? void 0 : medication.medication_items) !== null && _b !== void 0 ? _b : [];
    var printCb = (0, react_1.useCallback)(function () {
        function printElem(elem) {
            var newWindow = window.open("", "PRINT", "height=400,width=600");
            newWindow === null || newWindow === void 0 ? void 0 : newWindow.document.write("<html><head><title>" + document.title + "</title>");
            newWindow === null || newWindow === void 0 ? void 0 : newWindow.document.write("</head><body >");
            newWindow === null || newWindow === void 0 ? void 0 : newWindow.document.write(document.getElementById(elem).innerHTML);
            newWindow === null || newWindow === void 0 ? void 0 : newWindow.document.write("</body></html>");
            newWindow === null || newWindow === void 0 ? void 0 : newWindow.document.close(); // necessary for IE >= 10
            newWindow === null || newWindow === void 0 ? void 0 : newWindow.focus(); // necessary for IE >= 10*/
            newWindow === null || newWindow === void 0 ? void 0 : newWindow.print();
            return true;
        }
        printElem("printingMedication");
    }, [type]);
    printFnRef.current = printCb;
    var arr = {
        "1/24": "مره في اليوم",
        "1/12": "كل 12 ساعة",
        "1/8": "كل 8 ساعات",
        "1/6": "كل 6 ساعات",
        "1/5": "كل 5 ساعات",
        onNeed: "عند الحاجة",
    };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ style: {
            // visibility: "visible"
            display: "".concat(type),
        } }, { children: medicationItemsExternal.length == 0 ? null : ((0, jsx_runtime_1.jsxs)("div", __assign({ id: "printingMedication" }, { children: [(0, jsx_runtime_1.jsx)("p", __assign({ style: {
                        textAlign: "center",
                        margin: 2,
                        fontWeight: "bolder",
                        fontSize: 24,
                    } }, { children: "منظمة الأطباء المستقلين" })), (0, jsx_runtime_1.jsx)("p", __assign({ style: { textAlign: "center", margin: 2 } }, { children: (_d = (_c = warehousesList_1.globalWarehousesData[medication === null || medication === void 0 ? void 0 : medication.center_id]) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : "" })), (0, jsx_runtime_1.jsx)("p", __assign({ style: { textAlign: "center", margin: 2 } }, { children: "وصفة طبية" })), (0, jsx_runtime_1.jsx)("p", __assign({ style: { textAlign: "center", margin: 2 } }, { children: t("common.fullDateTime", {
                        date: (_e = medication === null || medication === void 0 ? void 0 : medication.prescribe_date) !== null && _e !== void 0 ? _e : "",
                    }) })), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("p", __assign({ style: { textAlign: "center", margin: 2 } }, { children: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0631\u064A\u0636: ".concat(medication === null || medication === void 0 ? void 0 : medication.cached_patient_name, " ") })), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", __assign({ style: {
                            // position: 'absolute',
                            // zIndex: 0,
                            // background: 'white',
                            // display: 'block',
                            // minHeight: '50%',
                            // minWidth: '50%',
                            // color: 'yellow',
                            // margin: '0 auto',
                            } }, { children: (0, jsx_runtime_1.jsx)("p", __assign({ style: {
                                    textAlign: "center",
                                    // color: 'lightgrey',
                                    fontSize: "20px",
                                    // transform: 'rotate(60deg)',
                                    // WebkitTransform: 'rotate(60deg)',
                                } }, { children: "الوصفة المصروفة/الخارجية" })) })), (0, jsx_runtime_1.jsx)("div", __assign({ style: {
                                // position: 'absolute',
                                zIndex: 1,
                            } }, { children: (0, jsx_runtime_1.jsx)("ol", __assign({ style: { textAlign: "right", direction: "rtl" } }, { children: (medicationItemsExternal || []).map(function (item, index) {
                                    return ((0, jsx_runtime_1.jsxs)("li", { children: [(0, jsx_runtime_1.jsxs)("p", __assign({ style: {
                                                    textAlign: "right",
                                                    direction: "rtl",
                                                    margin: 2,
                                                } }, { children: [(0, jsx_runtime_1.jsxs)("span", { children: ["الدواء والتركيز", " ", ": "] }), (0, jsx_runtime_1.jsx)("span", { children: item.cached_product_name }), " - ", (0, jsx_runtime_1.jsx)("span", { children: item.cached_product_description }), "  __  ", (0, jsx_runtime_1.jsxs)("span", { children: ["الشكل الدوائي", " ", ": "] }), (0, jsx_runtime_1.jsx)("span", { children: item.cached_product_unit_name }), "  __  ", (0, jsx_runtime_1.jsxs)("span", { children: ["الجرعة", " ", ": "] }), (0, jsx_runtime_1.jsx)("span", { children: item.quantity }), "  __  ", (0, jsx_runtime_1.jsxs)("span", { children: ["التواتر", " ", ": "] }), (0, jsx_runtime_1.jsx)("span", { children: arr[item === null || item === void 0 ? void 0 : item.per] }), "  __  ", (0, jsx_runtime_1.jsxs)("span", { children: ["المدة/ايام", " ", ": "] }), (0, jsx_runtime_1.jsx)("span", { children: item.via }), "  __  ", (0, jsx_runtime_1.jsxs)("span", { children: ["الكمية الكلية", " ", ": "] }), (0, jsx_runtime_1.jsx)("span", { children: item.overall_quantity })] })), (0, jsx_runtime_1.jsx)("hr", { style: { width: "100%" } })] }, index));
                                }) })) })), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {})] })] }))) })));
}
exports.default = PrescriptionMedicationPrint;
